import { render, staticRenderFns } from "./materials-list.vue?vue&type=template&id=5f91c2e8&scoped=true&"
import script from "./materials-list.vue?vue&type=script&lang=js&"
export * from "./materials-list.vue?vue&type=script&lang=js&"
import style0 from "./materials-list.vue?vue&type=style&index=0&id=5f91c2e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f91c2e8",
  null
  
)

export default component.exports